/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ quantity: NonNullable<unknown>, unitPrice: NonNullable<unknown> }} Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs */

const en_admin_external_booking_edit_order_summary_extra_price_item = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} per item`)
};

const de_admin_external_booking_edit_order_summary_extra_price_item = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} pro Einheit`)
};

const es_admin_external_booking_edit_order_summary_extra_price_item = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} por item`)
};

const fr_admin_external_booking_edit_order_summary_extra_price_item = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} par article`)
};

const nl_admin_external_booking_edit_order_summary_extra_price_item = /** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.quantity} × ${i?.unitPrice} per stuk`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */
const it_admin_external_booking_edit_order_summary_extra_price_item = en_admin_external_booking_edit_order_summary_extra_price_item;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_order_summary_extra_price_item = en_admin_external_booking_edit_order_summary_extra_price_item;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */
const pl_admin_external_booking_edit_order_summary_extra_price_item = en_admin_external_booking_edit_order_summary_extra_price_item;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */
const hu_admin_external_booking_edit_order_summary_extra_price_item = en_admin_external_booking_edit_order_summary_extra_price_item;

/** @type {(inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs) => LocalizedString} */
const ro_admin_external_booking_edit_order_summary_extra_price_item = en_admin_external_booking_edit_order_summary_extra_price_item;

/**
* | output |
* | --- |
* | "{quantity} × {unitPrice} per item" |
*
* @param {Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_order_summary_extra_price_item = /** @type {((inputs: Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Order_Summary_Extra_Price_ItemInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_order_summary_extra_price_item(inputs)
	if (locale === "de") return de_admin_external_booking_edit_order_summary_extra_price_item(inputs)
	if (locale === "es") return es_admin_external_booking_edit_order_summary_extra_price_item(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_order_summary_extra_price_item(inputs)
	if (locale === "nl") return nl_admin_external_booking_edit_order_summary_extra_price_item(inputs)
	if (locale === "it") return it_admin_external_booking_edit_order_summary_extra_price_item(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_order_summary_extra_price_item(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_order_summary_extra_price_item(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_order_summary_extra_price_item(inputs)
	return ro_admin_external_booking_edit_order_summary_extra_price_item(inputs)
});
export { admin_external_booking_edit_order_summary_extra_price_item as "admin.external_booking_edit.order_summary.extra_price_item" }